import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { View } from "ui/atoms/view";
import { Button } from "ui/gluestack/button";
import { Text } from "react-native";
import { useHandleRoleForm } from "./roles/hooks/useHandleRoleForm";
import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { useHandleUserForm } from "./users/hooks/useHandleUserForm";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  role?: RoleModel;
  user?: AuthUserModel;
}

export function DeleteRoleUserModal({
  isVisible,
  onClose,
  onSuccess,
  role,
  user,
}: Props) {
  const { handleDeleteRole, isLoadingAction: isRoleDeleting } =
    useHandleRoleForm(onSuccess, role);

  const { handleDeleteUser, isLoadingAction: isUserDeleting } =
    useHandleUserForm(onSuccess, user);

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      className="w-full max-w-[378px] mx-auto"
      title={`Are you sure you want to delete this ${user ? "user" : "role"}?`}
      description={`This action will remove this  ${user ? "user" : "role"} permanently and cannot be undone. Please confirm if you want to proceed.`}
      hasCancelButton
    >
      <View className="flex flex-row justify-end gap-x-4 ">
        <Button action="primary" size="sm" variant="outline" onPress={onClose}>
          <Text className="text-primary-500 font-semibold">Cancel</Text>
        </Button>
        <Button
          action="negative"
          size="sm"
          disabled={isRoleDeleting || isUserDeleting}
          onPress={() => {
            if (user) {
              handleDeleteUser({ id: user.id });
            } else if (role) {
              handleDeleteRole({ id: role.id });
            }
          }}
        >
          <Text className="text-white">Delete</Text>
        </Button>
      </View>
    </ReusableModal>
  );
}
